import './Table.css';
import { ReactNode } from 'react';

type TableProps = {
	children: ReactNode;
	className?: string;
	trackRow?: boolean; // highlights row on mouse hover
	interactive?: boolean; // highlights row on mouse hover and show pointer cursor
	striped?: boolean; // a striped table
	loaderIcon?: ReactNode;
};

export const Table = ({ children, className = '', trackRow, interactive, striped, loaderIcon }: TableProps) => {
	return (
		<div className="table-container">
			{loaderIcon}
			<table
				className={`table ${className} ${trackRow ? 'track-row' : ''} ${interactive ? 'interactive' : ''} ${
					striped ? 'striped' : ''
				}`}
			>
				{children}
			</table>
		</div>
	);
};
